module.exports = __webpack_public_path__ + "static/media/wpforms2.62c26a56.png";